import { Box, Typography } from "@mui/material";
import { Autorenew } from "@mui/icons-material";

const SectionHeader = ({ title, refreshing, mb = 2, mt = 3, children }) => (
  <Box className="flex items-center" mb={mb} mt={mt}>
    <Typography variant="h3" sx={{ textTransform: "capitalize" }}>
      {title}
    </Typography>

    {children}

    {refreshing && <Autorenew className="rotateIcon" sx={{ ml: 1 }} />}
  </Box>
);

export default SectionHeader;
